import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt, FaHome, FaBuilding, FaKey } from 'react-icons/fa';

function Home() {
    return (
        <main>
            {/* Hero Section */}
            <section
                className="text-white d-flex align-items-center"
                style={{
                    background: 'linear-gradient(rgba(0,0,0,0.55), rgba(0,0,0,0.55)), url(/assets/images/hero-cleaning.jpg) center/cover no-repeat',
                    minHeight: '85vh'
                }}
            >
                <Container>
                    <Row className="align-items-center">
                        <Col md={7}>
                            <h1 className="display-3 fw-bold mb-3 darker-heading">
                                Making Spaces Shine
                            </h1>

                            <p className="home-intro-text">
                                Shiny Squad Cleaning delivers spotless results for homes, offices, and rentals in Utah County — every time.
                            </p>

                            <Button variant="primary" size="lg" className="me-3 shadow-sm" href="/contact">
                                Get a Free Quote
                            </Button>
                            <Button variant="outline-light" size="lg" href="/listings">
                                Our Services
                            </Button>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* About / Quick Info */}
            <section className="py-5">
                <Container>
                    <Row className="text-center mb-5">
                        <h2 className="fw-semibold">Why Choose Shiny Squad?</h2>
                        <p className="text-muted fs-5">Professional, reliable, and detail-oriented cleaning you can trust.</p>
                    </Row>
                    <Row className="g-4 text-center">
                        <Col md={4}>
                            <FaHome size={40} className="text-primary mb-3" />
                            <h5>Residential Cleaning</h5>
                            <p>From deep cleans to regular maintenance, we keep your home spotless.</p>
                        </Col>
                        <Col md={4}>
                            <FaBuilding size={40} className="text-primary mb-3" />
                            <h5>Commercial Cleaning</h5>
                            <p>Professional environments stay clean, fresh, and welcoming for clients.</p>
                        </Col>
                        <Col md={4}>
                            <FaKey size={40} className="text-primary mb-3" />
                            <h5>Rental Cleaning</h5>
                            <p>Perfect for Airbnb and short-term rentals — fast turnaround, top results.</p>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* Contact Info */}
            <section className="py-5">
                <Container>
                    <Row className="g-4 text-center">
                        <Col md={4}>
                            <FaPhoneAlt size={24} className="text-primary mb-2" />
                            <p className="mb-0"><a href="tel:+13854501232" className="text-decoration-none text-dark">(385) 450-1232</a></p>
                        </Col>
                        <Col md={4}>
                            <FaEnvelope size={24} className="text-primary mb-2" />
                            <p className="mb-0"><a href="mailto:shinysquadcleaning@gmail.com" className="text-decoration-none text-dark">shinysquadcleaning@gmail.com</a></p>
                        </Col>
                        <Col md={4}>
                            <FaMapMarkerAlt size={24} className="text-primary mb-2" />
                            <p className="mb-0">Orem, Utah — Serving Utah County</p>
                        </Col>
                    </Row>
                </Container>
            </section>
        </main>
    );
}

export default Home;
